<template>
  <PageLoading :loading="loading">
    <!-- 错误页面 -->
    <ErrorPage v-if="hasError" :title="errorTitle" :message="errorMessage" />

    <!-- 正常页面 -->
    <div v-else class="milk-notice">
      <!-- 空状态 -->
      <div v-if="noticeData.length == 0" class="empty-state">
        <van-empty description="暂无订奶须知" />
      </div>
      <!-- 订奶须知内容 -->
      <div v-else class="notice-container">
        <van-image :src="item" v-for="item in noticeData" :key="item" />
      </div>
    </div>
  </PageLoading>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { setWxTitle } from '@/utils/wx'
import { post } from '@/utils/request'
import { WECHAT_APPID } from '../../../config/env'

// 加载状态
const loading = ref(true)

// 错误状态
const hasError = ref(false)
const errorTitle = ref('')
const errorMessage = ref('')

// 订奶须知数据
const noticeData = ref([])

// 处理错误
const handleError = (title, message) => {
  hasError.value = true
  errorTitle.value = title
  errorMessage.value = message
  loading.value = false
}

onMounted(() => {
  setWxTitle('订奶须知')
  initPage()
})

// 页面初始化
const initPage = async () => {
  try {
    // 调用接口获取订奶须知数据
    const res = await post('/api/view/milk/order/info', {
      app_id: WECHAT_APPID,
    })
    if (res.result && res.result.state === 'ok') {
      noticeData.value = res.result.account_info.order_description_attachment_ids || []
    } else {
      handleError('加载失败', res.result?.message || '接口异常')
    }
  } catch (error) {
    console.error('页面初始化失败:', error)
    handleError('加载失败', '页面加载失败，请重试')
  } finally {
    loading.value = false
  }
}
</script>

<style scoped>
.milk-notice {
  min-height: 100vh;
  background: #fff;
}
.empty-state {
  padding: 60px 0;
  text-align: center;
}
</style>